import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import {
  FaUser,
  FaSignOutAlt,
  FaAngleLeft,
  FaAngleRight,
  FaArchive,
  FaChartBar,
  FaCalculator,
  FaBoxOpen,
  FaUserFriends,
  FaAngleDown,
  FaMapMarkerAlt,
  FaTags,
  FaQuestionCircle,
  FaBars,
  FaWallet,
  FaBoxes,
  FaShoppingCart,
  FaShoppingBag,
  FaWarehouse,
  FaTruckLoading,
  FaUndo,
  FaMoneyBillWave,
  FaHistory,
  FaCog 
} from "react-icons/fa";
import logo from "../../Images/logo2.png";
import profile from "../../Images/profile.jpg";
import { toast } from "react-toastify";
import { Navigate, useNavigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  REMOVE_ACTIVE_USER,
  selectFullName,
  selectImgUrl,
  selectRoleId,
  selectIsLoggedIn,
  selectLocationName,
  selectWithSalesQuotation,
  SET_SalesOrderConfig,
} from "../../redux/IchthusSlice";
import Loader from "../../components/loader/Loader";
import { domain } from "../../security";
import FetchFailedHelp from "../../components/Admin/Batches/HelpFAQ/FetchFailedHelp";

const Admin = () => {
  // --- State ---
  const [open, setOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1280);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [rolePermissions, setRolePermissions] = useState(null);
  const [loadingPermissions, setLoadingPermissions] = useState(true);
  const [fetchFailed, setFetchFailed] = useState(false);

  // --- Hooks ---
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // --- Redux Selectors ---
  const fullName = useSelector(selectFullName);
  const imgUrl = useSelector(selectImgUrl);
  const roleId = useSelector(selectRoleId);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const LocationName = useSelector(selectLocationName);
  const withSalesQuotation = useSelector(selectWithSalesQuotation);

  // --- Menu Data ---
  const Menus = useMemo(
    () => [
      {
        title: "Dashboard",
        path: "dashboard",
        Icon: FaChartBar,
        permissionKey: "dashboard",
      },
      {
        title: "Maintenance",
        Icon: FaBoxOpen,
        dropdown: [
          // Group 1: Product Setup
          { title: "- Product Setup -", isGroupHeader: true },
          {
            title: "Inventory Status",
            path: "InventoryStatus",
            permissionKey: "inventoryStatus",
          },
          {
            title: "Unit Of Measurement",
            path: "UnitOfMeasurement",
            permissionKey: "unitOfMeasurement",
          },
          {
            title: "Item Types",
            path: "ItemTypes",
            Icon: FaTags,
            permissionKey: "itemTypes",
          },
          {
            title: "Categories",
            path: "categories",
            permissionKey: "categories",
          },
          {
            title: "Categories 2",
            path: "categories2",
            permissionKey: "categories2",
          },
          {
            title: "Categories 3",
            path: "categories3",
            permissionKey: "categories3",
          },
          {
            title: "Categories 4",
            path: "categories4",
            permissionKey: "categories4",
          },
          {
            title: "Categories 5",
            path: "categories5",
            permissionKey: "categories5",
          },
          { title: "Brands", path: "brands", permissionKey: "brands" },

          // Group 2: Shipment
          { title: "- Shipment -", isGroupHeader: true },
          {
            title: "Logistics Personnel",
            path: "AllLogisticsPersonnel",
            Icon: FaUserFriends,
            permissionKey: "logisticsPersonnel",
          },
          {
            title: "Vehicles",
            path: "AllVehicles",
            Icon: FaUserFriends,
            permissionKey: "vehicles",
          },
          // Group 3: Production
          { title: "- Production -", isGroupHeader: true },
          {
            title: "Warehouses",
            path: "warehouses",
            permissionKey: "warehouses",
          },
          {
            title: "AllProductionTagging",
            path: "AllProductionTagging",
            Icon: FaWallet,
            permissionKey: "productionTagging",
          },
          { title: "- Others -", isGroupHeader: true },
          {
            title: "Terms",
            path: "terms",
            permissionKey: "terms",
          },
        ],
      },
      {
        title: "Procurement",
        Icon: FaShoppingCart,
        permissionKey: "procurement",
        dropdown: [
          {
            title: "Purchase Orders",
            path: "PurchaseOrders",
            permissionKey: "purchaseOrders",
          },
          {
            title: "Goods Receipts",
            path: "GoodsReceipts",
            permissionKey: "goodsReceipts",
          },
        ],
      },
      {
        title: "Sales",
        Icon: FaShoppingBag,
        permissionKey: "sales",
        dropdown: [
          ...(withSalesQuotation
            ? [
                {
                  title: "Sales Quotations",
                  path: "SalesQuotations",
                  permissionKey: "salesQuotations",
                },
              ]
            : []),
          {
            title: "Sales Quotation",
            path: "AllQuotationSales",
            permissionKey: "allQuotationSales",
          },
          {
            title: "Sales Orders",
            path: "SalesOrders",
            permissionKey: "salesOrders",
          },
          {
            title: "Delivery Orders",
            path: "DeliveryOrders",
            permissionKey: "deliveryOrders",
          },
          /* {
            title: "Production",
            path: "AllProduction",
            permissionKey: "production",
          },
          {
            title: "Operations Production",
            path: "ActualMeasurements",
            permissionKey: "operationsProduction",
          },
          {
            title: "Warehouse Requests",
            path: "Allwarehouserequests",
            permissionKey: "warehouseRequests",
          },
          {
            title: "Warehouse Stock",
            path: "AllWarehouseStock",
            permissionKey: "warehouseStock",
          }, */
        ],
      },
      {
        title: "Production",
        Icon: FaWarehouse,
        permissionKey: "production",
        dropdown: [
          {
            title: "Production",
            path: "AllProduction",
            permissionKey: "production",
          },
          {
            title: "Operations Production",
            path: "ActualMeasurements",
            permissionKey: "operationsProduction",
          },
          {
            title: "Warehouse Requests",
            path: "Allwarehouserequests",
            permissionKey: "warehouseRequests",
          },
          {
            title: "Warehouse Stock",
            path: "AllWarehouseStock",
            permissionKey: "warehouseStock",
          },
        ],
      },

      {
        title: "Shipment & Delivery",
        Icon: FaTruckLoading,
        permissionKey: "shipment",
        dropdown: [
          {
            title: "Shipment",
            path: "AllShipments",
            permissionKey: "shipment",
          },
        ],
      },

      {
        title: "Returns",
        Icon: FaUndo,
        permissionKey: "returns",
        dropdown: [
          {
            title: "Delivery Returns",
            path: "DeliveryReturns",
            permissionKey: "deliveryReturns",
          },
          {
            title: "Purchase Returns",
            path: "PurchaseReturns",
            permissionKey: "purchaseReturns",
          },
          {
            title: "Trade Returns",
            path: "TradeReturns",
            permissionKey: "tradeReturns",
          },
        ],
      },
      {
        title: "Prices",
        Icon: FaMoneyBillWave,
        permissionKey: "prices",
        dropdown: [
          {
            title: "Selling Price",
            path: "SellingPriceHistories",
            permissionKey: "sellingPriceHistories",
          },
          {
            title: "Purchase Price",
            path: "PurchasePriceHistories",
            permissionKey: "purchasePriceHistories",
          },
        ],
      },
      {
        title: "Inventory",
        Icon: FaArchive,
        permissionKey: "inventory",
        dropdown: [
          {
            title: "Inventory Dashboard",
            path: "inventory",
            permissionKey: "inventoryDashboard",
          },
          {
            title: "Item Details",
            path: "InventoryCost",
            permissionKey: "itemDetails",
          },
          {
            title: "Physical Inventory",
            path: "InventoryOverride",
            permissionKey: "physicalInventory",
          },
          {
            title: "Transfer",
            path: "transfer",
            permissionKey: "transferItems",
          },
        ],
      },
      {
        title: "Staff Access",
        Icon: FaUser,
        permissionKey: "staffAccess",
        dropdown: [
          { title: "Users", path: "users", permissionKey: "users" },
          {
            title: "Permissions",
            path: "userRestriction",
            permissionKey: "userRestriction",
          },
          { title: "Employees", path: "employees", permissionKey: "employees" },
          { title: "Approvers", path: "approvers", permissionKey: "approvers" },
        ],
      },
      {
        title: "Back Tracking",
        Icon: FaHistory,
        permissionKey: "backTracking",
        dropdown: [
          {
            title: "Stock Entry (Batches)",
            path: "batches",
            permissionKey: "batches",
          },
          {
            title: "Serial Numbers",
            path: "serial-numbers",
            permissionKey: "serialNumbers",
          },
          { title: "AuditLogs", path: "AuditLogs", permissionKey: "auditLogs" },
        ],
      },
      {
        title: "Settings",
        Icon: FaCog,
        permissionKey: "salesOrderSettings",
        dropdown: [
          {
            title: "Customer Credit",
            path: "AllCustomerCredit",
            Icon: FaWallet,
            permissionKey: "customerCredit",
          },
          {
            title: "Pricing Display",
            path: "AllPersonalizedItems",
            Icon: FaWallet,
            permissionKey: "pricingDisplay",
          },
          {
            title: "SalesOrderSettings",
            path: "AllSalesOrderSettings",
            Icon: FaWallet,
            permissionKey: "salesOrderSettings",
          },
        ],
      },
      {
        title: "Locations",
        path: "locations",
        Icon: FaMapMarkerAlt,
        permissionKey: "locations",
      },
      {
        title: "Products",
        path: "product-list",
        Icon: FaTags,
        permissionKey: "productList",
      },
      {
        title: "ProductBOM",
        path: "ProductBOM",
        Icon: FaBoxes,
        permissionKey: "productBom",
      },

      {
        title: "Customers",
        path: "customers",
        Icon: FaUserFriends,
        permissionKey: "customers",
      },
      {
        title: "Vendors",
        path: "vendors",
        Icon: FaUserFriends,
        permissionKey: "vendors",
      },
      {
        title: "Transactions",
        path: "transactions",
        Icon: FaChartBar,
        permissionKey: "transactions",
      },
      { title: "POS", path: "pos", Icon: FaCalculator, permissionKey: "pos" },
      { title: "Help & FAQ", path: "help-faq", Icon: FaQuestionCircle },
    ],
    [withSalesQuotation],
  );

  // --- Effects ---
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1280);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const activeMenu = Menus.find((menu) =>
      menu.dropdown?.some(
        (subItem) => subItem.path && location.pathname.includes(subItem.path),
      ),
    );
    if (activeMenu) {
      setOpenDropdown(activeMenu.title);
    }
  }, [location.pathname, Menus]);

  useEffect(() => {
    if (isLoggedIn && roleId) {
      const fetchData = async () => {
        setLoadingPermissions(true);
        setFetchFailed(false);
        try {
          const response = await axios.get(`${domain}/api/JobRole/${roleId}`);
          setRolePermissions(response.data);

          try {
            const settingsRes = await axios.get(
              `${domain}/api/SalesOrderSettings`,
            );
            dispatch(SET_SalesOrderConfig(settingsRes.data.withSalesQuotation));
          } catch (settingsError) {
            console.error(
              "Failed to fetch Sales Order Settings",
              settingsError,
            );
          }
        } catch (error) {
          console.error("Failed to fetch permissions", error);
          toast.error("Connection Error: Could not fetch permissions.");
          setRolePermissions(null);
          setFetchFailed(true);
        } finally {
          setLoadingPermissions(false);
        }
      };
      fetchData();
    } else if (!isLoggedIn) {
      setRolePermissions(null);
      setLoadingPermissions(false);
    }
  }, [roleId, isLoggedIn, dispatch]);

  if (!isLoggedIn) return <Navigate to="/signin" />;

  // --- Helpers ---
  const isSidebarExpanded = (isDesktop && open) || mobileOpen;

  const logoutUser = () => {
    toast.success("Logout Successful.");
    dispatch(REMOVE_ACTIVE_USER());
    setRolePermissions(null);
    navigate("/signin");
  };

  const handleMenuClick = (menu) => {
    if (menu.path) {
      navigate(`/admin/${menu.path}`);
      setOpenDropdown(null);
      if (!isDesktop) setMobileOpen(false);
    } else if (menu.dropdown) {
      if (!isSidebarExpanded && isDesktop) setOpen(true);
      setOpenDropdown(openDropdown === menu.title ? null : menu.title);
    }
  };

  const canDisplayMenu = (menu) => {
    if (!rolePermissions) return false;
    if (!menu.permissionKey && !menu.dropdown) return true;
    if (menu.dropdown) {
      return menu.dropdown.some((subItem) => {
        if (subItem.isGroupHeader) return false;
        return subItem.permissionKey
          ? rolePermissions[subItem.permissionKey] === true
          : true;
      });
    }
    return rolePermissions[menu.permissionKey] === true;
  };

  const isMenuActive = (menu) => {
    if (menu.path) return location.pathname.includes(menu.path);
    if (menu.dropdown)
      return menu.dropdown.some(
        (sub) => sub.path && location.pathname.includes(sub.path),
      );
    return false;
  };

  return (
    <div className="flex h-screen bg-slate-50 overflow-hidden font-sans text-slate-800">
      {mobileOpen && !isDesktop && (
        <div
          className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-40 transition-opacity duration-300"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <aside
        className={`fixed top-0 left-0 z-50 h-screen bg-slate-900 text-slate-300 shadow-2xl transition-all duration-300 ease-in-out flex flex-col border-r border-slate-800
          ${
            isDesktop
              ? open
                ? "w-72"
                : "w-20"
              : mobileOpen
                ? "w-72 translate-x-0"
                : "w-72 -translate-x-full"
          }`}
      >
        {isDesktop && (
          <button
            className="absolute top-8 -right-3.5 w-7 h-7 bg-indigo-600 hover:bg-indigo-500 text-white rounded-full flex items-center justify-center shadow-lg shadow-indigo-500/30 z-50 transition-transform focus:outline-none"
            onClick={() => setOpen(!open)}
          >
            {open ? <FaAngleLeft size={14} /> : <FaAngleRight size={14} />}
          </button>
        )}

        <div className="flex items-center gap-3 px-5 h-20 shrink-0 border-b border-slate-800/60">
          <img
            src={logo}
            alt="logo"
            className={`w-9 h-9 object-contain drop-shadow-md transition-all duration-500 ${
              isSidebarExpanded ? "rotate-0" : "rotate-[360deg] mx-auto"
            }`}
          />
          {isSidebarExpanded && (
            <h1 className="text-white font-bold text-xl tracking-wide whitespace-nowrap transition-opacity duration-300">
              POINT 7
            </h1>
          )}
        </div>

        {/* --- UPDATED: User Profile Snippet --- */}
        <div className="px-4 py-4 shrink-0">
          <div
            onClick={() => handleMenuClick({ path: "manage-account" })}
            className={`flex items-center transition-all duration-300 rounded-xl overflow-hidden cursor-pointer group hover:bg-slate-800/80 hover:ring-1 hover:ring-indigo-500/50
              ${isSidebarExpanded ? "bg-slate-800/50 p-3 gap-3 shadow-inner border border-slate-700/50" : "justify-center p-0"}
            `}
            title="Manage Your Account"
          >
            {loadingPermissions ? (
              <Loader size={16} color="white" />
            ) : (
              <>
                <img
                  src={imgUrl || profile}
                  alt="Profile"
                  className={`rounded-full border-2 border-slate-600 object-cover shrink-0 transition-all duration-300 ${
                    isSidebarExpanded
                      ? "w-10 h-10 group-hover:border-indigo-400"
                      : "w-10 h-10 mx-auto group-hover:border-indigo-400"
                  }`}
                />
                <div
                  className={`flex flex-col justify-center transition-all duration-300 overflow-hidden ${
                    isSidebarExpanded
                      ? "opacity-100 w-auto"
                      : "opacity-0 w-0 hidden"
                  }`}
                >
                  <p className="text-sm font-semibold text-white truncate w-36 group-hover:text-indigo-300 transition-colors">
                    {fullName || "User"}
                  </p>
                  <p className="text-[11px] text-indigo-400/80 font-medium truncate w-36 mt-0.5">
                    {LocationName}
                  </p>
                </div>
              </>
            )}
          </div>
        </div>

        <nav className="flex-grow px-4 py-2 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="space-y-1.5 pb-10">
            {Menus.filter(canDisplayMenu).map((menu, index) => {
              const isActive = isMenuActive(menu);
              const isDropdownOpen = openDropdown === menu.title;

              return (
                <div key={index} className="relative group/menu">
                  {!isSidebarExpanded && (
                    <div className="absolute left-14 top-1/2 -translate-y-1/2 ml-4 px-3 py-2 bg-slate-800 text-white text-xs font-medium rounded-md opacity-0 group-hover/menu:opacity-100 pointer-events-none transition-opacity duration-200 z-50 shadow-xl whitespace-nowrap">
                      {menu.title}
                    </div>
                  )}

                  <div
                    onClick={() => handleMenuClick(menu)}
                    className={`
                      relative flex items-center justify-between p-3 rounded-xl cursor-pointer transition-all duration-200 group
                      ${
                        isActive && !menu.dropdown
                          ? "bg-indigo-600 text-white shadow-md shadow-indigo-600/20"
                          : isDropdownOpen && isSidebarExpanded
                            ? "bg-slate-800/80 text-white shadow-inner"
                            : "text-slate-400 hover:bg-slate-800 hover:text-white"
                      }
                      ${!isSidebarExpanded && "justify-center"}
                    `}
                  >
                    <div className="flex items-center gap-3.5">
                      <menu.Icon
                        className={`text-[1.15rem] transition-colors ${
                          isActive && !menu.dropdown
                            ? "text-white"
                            : "group-hover:text-indigo-400"
                        }`}
                      />
                      {isSidebarExpanded && (
                        <span className="text-sm font-medium tracking-wide whitespace-nowrap">
                          {menu.title}
                        </span>
                      )}
                    </div>

                    {isSidebarExpanded && menu.dropdown && (
                      <FaAngleDown
                        size={12}
                        className={`transition-transform duration-300 ${
                          isDropdownOpen
                            ? "rotate-180 text-indigo-400"
                            : "text-slate-500 group-hover:text-slate-300"
                        }`}
                      />
                    )}
                  </div>

                  {menu.dropdown && isDropdownOpen && isSidebarExpanded && (
                    <div className="ml-2 mt-1.5 pl-3 border-l-[1.5px] border-slate-700/80 space-y-1">
                      {menu.dropdown
                        .filter((sub, idx, arr) => {
                          if (sub.isGroupHeader) {
                            let hasVisibleChild = false;
                            for (let i = idx + 1; i < arr.length; i++) {
                              if (arr[i].isGroupHeader) break;
                              if (
                                !arr[i].permissionKey ||
                                rolePermissions?.[arr[i].permissionKey] === true
                              ) {
                                hasVisibleChild = true;
                                break;
                              }
                            }
                            return hasVisibleChild;
                          }
                          return (
                            !sub.permissionKey ||
                            rolePermissions?.[sub.permissionKey] === true
                          );
                        })
                        .map((subItem, subIndex) => {
                          if (subItem.isGroupHeader) {
                            return (
                              <div
                                key={subIndex}
                                className={`px-2 pb-1 text-[11px] font-bold text-slate-500 uppercase tracking-wider select-none ${
                                  subIndex !== 0 ? "pt-4" : "pt-2"
                                }`}
                              >
                                {subItem.title}
                              </div>
                            );
                          }

                          const isSubActive =
                            subItem.path &&
                            location.pathname.includes(subItem.path);

                          return (
                            <div
                              key={subIndex}
                              onClick={() => handleMenuClick(subItem)}
                              className={`
                                relative text-[13px] px-3 py-2 cursor-pointer rounded-lg transition-all duration-200 flex items-center gap-2.5 group/sub
                                ${
                                  isSubActive
                                    ? "bg-indigo-500/10 text-indigo-400 font-semibold"
                                    : "text-slate-400 hover:text-slate-200 hover:bg-slate-800/50"
                                }
                              `}
                            >
                              <span
                                className={`w-1.5 h-1.5 rounded-full transition-all duration-200 ${
                                  isSubActive
                                    ? "bg-indigo-500 scale-125 shadow-[0_0_8px_rgba(99,102,241,0.8)]"
                                    : "bg-slate-600 group-hover/sub:bg-slate-400"
                                }`}
                              ></span>
                              {subItem.title}
                            </div>
                          );
                        })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </nav>

        <div className="p-4 mt-auto border-t border-slate-800 bg-slate-900/50 shrink-0">
          <div
            onClick={logoutUser}
            className={`
              flex items-center gap-3.5 p-3 rounded-xl cursor-pointer transition-all duration-200 text-slate-400 hover:bg-red-500/10 hover:text-red-400 group
              ${!isSidebarExpanded && "justify-center"}
            `}
          >
            <FaSignOutAlt
              size={18}
              className="group-hover:scale-110 transition-transform"
            />
            {isSidebarExpanded && (
              <span className="text-sm font-medium tracking-wide">
                Sign Out
              </span>
            )}
          </div>
        </div>
      </aside>

      <main
        className={`flex-1 flex flex-col min-h-screen transition-all duration-300 ease-in-out relative
          ${isDesktop ? (open ? "ml-72" : "ml-20") : "ml-0"}
        `}
      >
        {!isDesktop && (
          <header className="sticky top-0 z-30 flex items-center justify-between bg-white/90 backdrop-blur-md px-5 py-4 shadow-sm border-b border-gray-200">
            <div className="flex items-center gap-4">
              <button
                onClick={() => setMobileOpen(true)}
                className="text-slate-600 hover:text-indigo-600 transition-colors focus:outline-none"
              >
                <FaBars size={22} />
              </button>
              <h2 className="font-bold text-slate-800 text-lg tracking-wide">
                Menu
              </h2>
            </div>
            <img src={logo} alt="logo" className="w-8 h-8 drop-shadow-sm" />
          </header>
        )}

        <div className="flex-1 p-6 md:p-8 overflow-y-auto">
          <div className=" mx-auto h-full pb-10">
            {fetchFailed ? (
              <FetchFailedHelp />
            ) : loadingPermissions ? (
              <div className="h-full flex flex-col items-center justify-center text-slate-400 mt-32 space-y-4">
                <Loader />
                <p className="text-sm font-medium tracking-wide animate-pulse">
                  Loading Access Rights...
                </p>
              </div>
            ) : (
              <div className="animate-fade-in">
                <Outlet />
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Admin;
